import "@/App.css";
import { HelmetProvider } from "react-helmet-async";
import MotionProvider from "@/motion/MotionProvider";
import BackgroundStack from "@/motion/Background";
import SEO from "@/components/site/SEO";
import Nav from "@/components/site/Nav";
import Hero from "@/components/site/Hero";
import BrandStrip from "@/components/site/BrandStrip";
import Gallery from "@/components/site/Gallery";
import About from "@/components/site/About";
import Services from "@/components/site/Services";
import InstagramEmbed from "@/components/site/InstagramEmbed";
import Contact from "@/components/site/Contact";
import Footer from "@/components/site/Footer";

function App() {
    return (
        <HelmetProvider>
            <MotionProvider>
            <SEO />
            <div className="App grain relative overflow-x-clip">
                <BackgroundStack />
                <Nav />
                <main>
                    <Hero />
                    <BrandStrip />
                    <Gallery />
                    <About />
                    <Services />
                    <InstagramEmbed />
                    <Contact />
                </main>
                <Footer />
            </div>
            </MotionProvider>
        </HelmetProvider>
    );
}

export default App;
